import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import routerConstant from "service/constant/routerConstant";
import { faqType } from "service/constant/serviceConstant";
import type { IFaqList } from "service/interface/help";

interface Props {
  data: IFaqList[];
}

export function FaqListTable({ data }: Props) {
  const navigate = useNavigate();

  const handleTableClick = (id: number) => {
    navigate(`${routerConstant.FAQ.index}/${id}`);
  };

  return (
    <div className="w-ful">
      <table className="w-full divide-y divide-[#d1dff3]">
        <thead>
          <tr>
            <th
              scope="col"
              className="min-w-[55px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              ID
            </th>
            <th
              scope="col"
              className="min-w-[158px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              질문 종류
            </th>
            <th
              scope="col"
              className="min-w-[661px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              제목
            </th>
            <th
              scope="col"
              className="min-w-[149px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              생성일
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {data.map((faq) => (
            <tr
              key={faq.id}
              className="cursor-pointer even:bg-[#fbfbfb] hover:bg-blue-2"
              onClick={() => handleTableClick(faq.id)}
            >
              <td className="whitespace-nowrap px-[15px] py-[16px] text-M1 text-gray-5">
                {faq.id}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                {faqType[faq.type]}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                {faq.title}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {moment(faq.createdAt).format("YYYY-MM-DD")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
